import style from "./GameChanceCard.module.css";
import Button from "../../components/button/Button";

interface GameChanceCardProps {
  title: string;
  description: string;
  chance: number | undefined;
  onClick: () => void;
  icon: string;
}

const GameChanceCard = ({
  title,
  description,
  chance,
  onClick,
  icon,
}: GameChanceCardProps) => {
  return (
    <div className={style.container}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={`${process.env.PUBLIC_URL}/assets/icon/${icon}.svg`}
          alt="heart"
          className={style.icon}
        />
        <span className={style.title}>{title}</span>
      </div>
      <span className={style.desc}>{description}</span>
      <span className={style.chance}>
        تعداد {title}: {chance} عدد
      </span>
      <Button
        text="بچرخون"
        onclick={onClick}
        outlline
        className={style.button}
      />
    </div>
  );
};

export default GameChanceCard;
